import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import FolderItem from './folder-item';
import {
  createFolder as createFolderAction,
  renameFolder,
  selectFolder,
  editMessage,
  draftClean,
  selectMessage,
  clearApplicationFilteredMessages
} from '../../actions/application';
import { clearMessagesFilteredMessages, clearSelected } from '../../actions/messages';
import { setShowMoveFolderAlert } from '../../actions/folders';
import { clearSelectedAndRecover, setIsFullMessageContent } from '../../actions/messages';
import {clearSelectedMessage} from '../../services/application';
import {deleteFolder, findTrashFolder, FolderTypes, moveFolder} from '../../services/folder';
import { updateOrderFolderImap } from '../../services/accounts';
import {moveMessages, resetFolderMessagesCache} from '../../services/message';
import {getSelectedFolder, getShowMoveFolderAlert} from '../../selectors/folders';
import { persistApplicationNewMessageContent } from '../../services/indexed-db';
import './folder-list.scss';
import '../../styles/main.scss';
import ACTIONS, { setUserFolders } from '../../actions/lexon';
import { documentIdClear } from '../../actions/user';
import { Confirmation } from "../notification/";
import i18n from 'i18next';

export const DroppablePayloadTypes = {
  FOLDER: 'FOLDER',
  MESSAGES: 'MESSAGES'
};

export class FolderListClass extends Component {
  constructor(props) {
    super(props);

    const {folderTree, folders} = this.props;

    this.state = {
      toggleChildren: this.buildToggleChildren(folderTree, folders),
      loadFirstTime: true,
      localFolderTree: folderTree
    };
  }

  buildToggleChildren(folderTree, folders, previousToggleChildren = {}) {
    return folderTree.reduce((acc, folderReference) => {
      const folder = folders[folderReference.folderId];
      if (!folder || !folder.folderId) {
        return acc;
      }

      acc[folder.folderId] = Boolean(previousToggleChildren[folder.folderId]);

      return acc;
    }, {});
  }

  componentDidUpdate(prevProps) {
    const { folderTree, folders } = this.props;

    if (
      prevProps.folderTree !== folderTree ||
      prevProps.folders !== folders
    ) {
      this.setState(prevState => ({
        localFolderTree: folderTree,
        toggleChildren: this.buildToggleChildren(
          folderTree,
          folders,
          prevState.toggleChildren
        )
      }));
    }
  }


  async handleMoveFolderOrder(event, folderId, direction) {
    event.stopPropagation();

    const { localFolderTree } = this.state;

    const sortedFolders = [...localFolderTree]
      .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER));

    const folderIndex = sortedFolders.findIndex(folder => folder.folderId === folderId);
    if (folderIndex === -1) {
      return;
    }

    const targetIndex = direction === 'up' ? folderIndex - 1 : folderIndex + 1;
    if (targetIndex < 0 || targetIndex >= sortedFolders.length) {
      return;
    }

    const sourceFolderId = sortedFolders[folderIndex].folderId;
    const targetFolderId = sortedFolders[targetIndex].folderId;

    const updatedFolders = localFolderTree.map(folder => ({ ...folder }));
    const sourceFolder = updatedFolders.find(folder => folder.folderId === sourceFolderId);
    const targetFolder = updatedFolders.find(folder => folder.folderId === targetFolderId);

    if (!sourceFolder || !targetFolder) {
      return;
    }

    const tempOrder = sourceFolder.order;
    sourceFolder.order = targetFolder.order;
    targetFolder.order = tempOrder;

    let saveOrder = updatedFolders.map(folder => ({
      name: folder.folderId,
      order: folder.order
    }));

    const { userId, lexonToken } = this.props.lexon;
    const { email } = this.props;
    this.setState({ localFolderTree: updatedFolders });

    if (this.props.userFolders && this.props.userFolders.length > 0) {
      saveOrder = [
        ...saveOrder,
        ...this.props.userFolders.filter(
          userFolder => !saveOrder.some(so => so.name === userFolder.name)
        )
      ];
    }
    this.props.setUserFolders(saveOrder);
    updateOrderFolderImap(saveOrder, userId, email, lexonToken);
  }

  render() {
    const {
      folders,
      selectedFolder,
      toggle,
      collapsed,
      depth,
      showMoveFolderAlert,
      clearShowMoveFolderAlert
    } = this.props;

    const { localFolderTree } = this.state;

    return (
      <React.Fragment>
        { [...localFolderTree].sort((a, b) => a.order - b.order)
          .map((folderReference, index) => {
            const folder = folders[folderReference.folderId];
            const children =
              Array.isArray(folderReference.children) && folderReference.children.length > 0
                ? folderReference.children
                : (Array.isArray(folder?.children) ? folder.children : []);
            return (
              <div key={folder?.fullURL} className={`itemContainer`}>
                <FolderItem
                  key={folder?.folderId}
                  folderId={folder?.folderId?.replaceAll('=', '')}
                  label={folder?.name}
                  graphic={folder?.type.icon}
                  className={`folderItem`}
                  selected={selectedFolder && folder?.folderId === selectedFolder.folderId}
                  onClick={event => this.onClick(event, folder)}
                  draggable={FolderTypes.FOLDER === folder?.type}
                  onDragStart={event => FolderListClass.onDragStart(event, folder)}
                  onDrop={event => this.onDrop(event, folder)}
                  onRename={FolderTypes.INBOX === folder?.type ? null : event => this.onRename(event, folder)}
                  onAddChild={event => this.onAddChild(event, folder)}
                  onDelete={FolderTypes.FOLDER === folder?.type ? event => this.onDelete(event, folder) : null}
                  onMoveFolder={(event, direction) =>
                    this.handleMoveFolderOrder(event, folder.folderId, direction)}
                  unreadMessageCount={folder?.unreadMessageCount}
                  toggle={toggle}
                  toggleChildren={this.state.toggleChildren[folder?.folderId]}
                  newMessageCount={folder?.newMessageCount}
                  hasChildren={children.length > 0}
                  collapsed={collapsed}
                  checkSelectedChildren={ () => this.checkSelectedChildren(folder) }
                  level={depth}
                  folder={folder}
                  isFirst={index === 0}
                  isLast={index === localFolderTree.length - 1}
                />
                {(children.length > 0 && toggle && this.state.toggleChildren[folder?.folderId] &&
                  <nav
                    className={
                      `$mdc-list
                        childList 
                      ${folder?.fullName?.split('/').length > 0 && 'children-container'}
                    `}>
                    <div className={`${folder?.fullName?.split('/').length > 0 ? 'children-container-divider' : ''}`} />
                    <FolderList
                      folderTree={children}
                      folders={folders}
                      toggle={toggle && this.state.toggleChildren[folder?.folderId]}
                      collapsed={collapsed}
                      depth={depth + 1}
                    />
                  </nav>
                )}
              </div>
            );
          })}
        <Confirmation
          initialModalState={showMoveFolderAlert}
          onAccept={clearShowMoveFolderAlert}
          message={i18n.t("alerts.showMoveFolderAlert")}
          titleAccept={i18n.t("general.close")}
          confirmType="confirm-error"
          iconType="lf-icon lf-icon-close-round"
        />
        <style>
          {`
            .children-container {
              background: var(--ghost-white);
              position: relative;
              .children-container-divider {
                border-left: 1px solid var(--gray-blue);
                height: 100%;
                left: ${collapsed ? '15px' : '33px'};
                position: absolute;
              }
            }
          `}
        </style>
      </React.Fragment>
    );
  }

  checkSelectedChildren(currentFolder) {
    const newToggleChildren = {...this.state.toggleChildren, [currentFolder.folderId]: this.state.toggleChildren[currentFolder.folderId] ? false : true };
    this.setState({toggleChildren: newToggleChildren});
  }

  checkIfIsChildrenOfFolder(currentFolder, selectedFolder){
    if (
      currentFolder === null ||
      currentFolder === undefined ||
      !selectedFolder ||
      !selectedFolder.folderId
    ) {
      return false;
    }

    const children = Array.isArray(currentFolder.children) ? currentFolder.children : [];
    return currentFolder.folderId === selectedFolder.folderId
      ? true
      : children.length === 0
        ? false
        : children.some(child => this.checkIfIsChildrenOfFolder(child, selectedFolder));
  }

  onClick(event, folder) {
    event.stopPropagation();
    this.props.setInterveners(null);
    this.props.setSubjectEmail('');
    this.props.setIsCompose(false);
    window.dispatchEvent(new CustomEvent('CloseComposer'));
    this.props.setIsFullMessageContent(false);
    this.props.documentIdClear(null);
    this.props.selectFolder(folder);
    const { application } = this.props;
    if (application.newMessage !== null) {
      const { close, lexon, draftClean } = this.props;

      if (lexon.idCaseFile !== null && lexon.idCaseFile !== undefined) {
        window.dispatchEvent(new CustomEvent('RemoveCaseFile'));
        this.props.setCaseFile({
          casefile: null,
          bbdd: lexon.bbdd,
          idCompany: lexon.idCompany
        });
      }

      if (lexon.mailContacts) {
        this.props.setMailContacts(null);
      }
      draftClean();
      this.props.messageClean();
      close(application);
    }
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("ResetList"));
      this.props.messageClicked(null);
      this.props.clearListMessages();
    }, 500);
   
  }

  static onDragStart(event, folder) {
    const payload = {type: DroppablePayloadTypes.FOLDER, folder};
    event.dataTransfer.setData('application/json', JSON.stringify(payload));
  }

  onDrop(event, toFolder) {
    if (event.dataTransfer.types && Array.from(event.dataTransfer.types).includes('application/json')) {
      const payload = JSON.parse(event.dataTransfer.getData('application/json'));
      switch (payload.type) {
        case DroppablePayloadTypes.FOLDER: {
          const folderToMoveId = payload.folder.folderId;
          if (folderToMoveId !== toFolder.folderId && !toFolder.children.some(f => f.folderId === folderToMoveId)) {
            this.props.moveFolder(payload.folder, toFolder);
          }
          break;
        }
        case DroppablePayloadTypes.MESSAGES:
          this.props.moveMessages(payload.fromFolder, toFolder, payload.messages, this.props.application.user);
          break;
        default:
      }
    }
  }

  onRename(event, folder) {
    event.stopPropagation();
    this.props.renameFolder(folder);
  }

  onAddChild(event, folder) {
    event.stopPropagation();
    this.props.createChildInFolder(folder);
  }

  onDelete(event, folder) {
    event.stopPropagation();
    const trashFolder = findTrashFolder(this.props.foldersState);
    if (!folder || !trashFolder) {
      return;
    }
    if (!trashFolder.children.map(f => f.folderId).includes(folder.folderId)) {
      this.props.moveFolder(folder, trashFolder);
    } else {
      this.props.deleteFolder(folder);
    }
  }
}

FolderListClass.propTypes = {
  folderTree: PropTypes.array.isRequired,
  folders: PropTypes.object.isRequired,
  application: PropTypes.object,
  selectedFolder: PropTypes.object,
  foldersState: PropTypes.object,
  selectFolder: PropTypes.func,
  renameFolder: PropTypes.func,
  moveMessages: PropTypes.func,
  depth: PropTypes.number
};

FolderListClass.defaultProps = { depth: 1 };

const mapStateToProps = state => ({
  application: state.application,
  selectedFolder: getSelectedFolder(state) || {},
  showMoveFolderAlert: getShowMoveFolderAlert(state),
  selectedMessage: (state.application.selectedMessage) ? state.application.selectedMessage.messageId : null,
  foldersState: state.folders,
  messages: state.messages,
  lexon: state.lexon,
  email: state.login.formValues.user,
  userFolders: state.lexon.folders
});

const mapDispatchToProps = dispatch => ({
  close: application => {
    dispatch(editMessage(null));
    // Clear content (editorBlur may be half way through -> force a message in the service worker to clear content after)
    // noinspection JSIgnoredPromiseFromCall
    persistApplicationNewMessageContent(application, '');
  },
  setIsFullMessageContent: isFullMessageContent => dispatch(setIsFullMessageContent(isFullMessageContent)),
  draftClean: () => {
    dispatch(draftClean());
  },
  setCaseFile: casefile => dispatch(ACTIONS.setCaseFile(casefile)),
  setInterveners: interveners => dispatch(ACTIONS.setInterveners(interveners)),
  setSubjectEmail: subjectEmail => dispatch(ACTIONS.setSubjectEmail(subjectEmail)),
  setIsCompose: isCompose => dispatch(ACTIONS.setIsCompose(isCompose)),
  documentIdClear: documentsId => dispatch(documentIdClear(documentsId)),
  selectFolder: (folder, user, selectedMessage) => {
    dispatch(selectFolder(folder));
    clearSelectedMessage(dispatch);
    clearSelectedAndRecover(dispatch, selectedMessage);
    resetFolderMessagesCache(dispatch, user, folder);
    dispatch(clearApplicationFilteredMessages());
    dispatch(clearMessagesFilteredMessages());
  },
  renameFolder: folder => dispatch(renameFolder(folder)),
  createChildInFolder: folder => dispatch(createFolderAction(folder.folderId)),
  setUserFolders: folders => dispatch(setUserFolders(folders)),
  moveFolder: (user, folder, targetFolder) => moveFolder(dispatch, user, folder, targetFolder),
  deleteFolder: (user, folder) => deleteFolder(dispatch, user, folder),
  moveMessages: (credentials, fromFolder, toFolder, messages, user, lexon) => {
    moveMessages(
      dispatch,
      credentials,
      fromFolder,
      toFolder,
      messages,
      user,
      lexon
    );
  },
  setMailContacts: mailContacts =>
    dispatch(ACTIONS.setMailContacts(mailContacts)),
  messageClean: () => {
    dispatch(selectMessage({}));
  },
  clearShowMoveFolderAlert: () => {
    dispatch(setShowMoveFolderAlert(false));
  },
  messageClicked: message =>
    dispatch(selectMessage(message)),
    clearListMessages: () => dispatch(clearSelected())
  });

const mergeProps = (stateProps, dispatchProps, ownProps) => (Object.assign({}, stateProps, dispatchProps, ownProps, {
  selectFolder: folder =>
    dispatchProps.selectFolder(folder, stateProps.application.user),
  moveFolder: (folder, targetFolder) => dispatchProps.moveFolder(stateProps.application.user, folder, targetFolder),
  deleteFolder: folder => dispatchProps.deleteFolder(stateProps.application.user, folder),
  moveMessages: (fromFolder, toFolder, message) =>
    dispatchProps.moveMessages(
      stateProps.application.user.credentials,
      fromFolder,
      toFolder,
      message,
      stateProps.application.user,
      stateProps.lexon,
    )
}));

const FolderList = connect(mapStateToProps, mapDispatchToProps, mergeProps)(FolderListClass);
export default FolderList;
